import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { PrimengModule } from './components/primeng/primeng.module';
import { AuthRoutingModule } from 'src/app/features/auth/auth-routing.module';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { SpinnerLoadComponent } from './components/spinner-load/spinner-load.component';



@NgModule({
  declarations: [
    SidebarComponent,
    SpinnerComponent,
    SpinnerLoadComponent
  ],
  imports: [
    CommonModule,
    PrimengModule,
    AuthRoutingModule
  ],
  exports: [
    SidebarComponent,
    SpinnerComponent,
    SpinnerLoadComponent
  ]
})
export class SharedModule { }
